'use strict';

function parse (rawValue) {
  const parsed = parseValue(rawValue);

  if (parsed === undefined) {
    return null;
  }

  return parsed;
}

function parseValue (rawValue) {
  try {
    return JSON.parse(rawValue);
  } catch (err) {
    return rawValue;
  }
}

module.exports = parse;



//////////////////
// WEBPACK FOOTER
// ./~/local-storage/parse.js
// module id = 644
// module chunks = 2